import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

const authToken = 'b5207eb87640a014da2a5c7b76334e98';

export const production = process.env.NODE_ENV === 'production';
const {
  VUE_APP_API_DOMAIN = 'https://staging-api.pixerymedia.com',
} = process.env;

axios.interceptors.response.use(response => response, (error) => {});

export const api = axios.create({
  baseURL: production ? `${VUE_APP_API_DOMAIN}/api/v1` : '/api-proxy',
  headers: { Authorization: `Bearer ${authToken}` },
});

Vue.use(VueAxios, axios);
